// Lightweight Google Analytics 4 event helper.
// Safe to call anywhere — if gtag isn't loaded or consent is denied
// (gtag sets a ga-disable flag), these calls are no-ops.

export const trackEvent = (action, params = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', action, params);
  }
};

// A lead/conversion was generated (quote, contact, etc.)
export const trackLead = (form, params = {}) => {
  const ft = getFirstTouch();
  trackEvent('generate_lead', {
    form,
    lead_source: ft.source || 'direct',
    lead_medium: ft.medium || 'none',
    lead_campaign: ft.campaign || '',
    ...params,
  });
};

// A CTA button was clicked
export const trackCta = (label, location, params = {}) =>
  trackEvent('cta_click', { cta_label: label, cta_location: location, ...params });

// An outbound link was clicked
export const trackOutbound = (url, label) =>
  trackEvent('click_outbound', { link_url: url, link_label: label });

// A contact method was used (phone / email)
export const trackContactClick = (method, value) =>
  trackEvent('contact_click', { method, value });

// --- Traffic source attribution -------------------------------------------
const FIRST_TOUCH_KEY = 'inspectiq_first_touch';

const classifyReferrer = (ref) => {
  if (!ref) return { source: 'direct', medium: 'none' };
  try {
    const host = new URL(ref).hostname.replace('www.', '');
    if (/google\./.test(host)) return { source: 'google', medium: 'organic' };
    if (/bing\./.test(host)) return { source: 'bing', medium: 'organic' };
    if (/(facebook|instagram|linkedin|t\.co|twitter|x\.com|youtube)\./.test(host))
      return { source: host, medium: 'social' };
    if (/imdg\.inspectiq\.in/.test(host)) return { source: 'imdg-tool', medium: 'referral' };
    return { source: host, medium: 'referral' };
  } catch (e) {
    return { source: 'direct', medium: 'none' };
  }
};

// Reads UTM params + referrer, persists first-touch attribution, returns current source.
export const captureTrafficSource = () => {
  if (typeof window === 'undefined') return {};
  const params = new URLSearchParams(window.location.search);
  const fromUtm = params.get('utm_source');

  const current = fromUtm
    ? {
        source: params.get('utm_source') || 'unknown',
        medium: params.get('utm_medium') || 'referral',
        campaign: params.get('utm_campaign') || '',
        term: params.get('utm_term') || '',
        content: params.get('utm_content') || '',
      }
    : { ...classifyReferrer(document.referrer), campaign: '', term: '', content: '' };

  // Persist the first touch only
  try {
    if (!localStorage.getItem(FIRST_TOUCH_KEY)) {
      localStorage.setItem(
        FIRST_TOUCH_KEY,
        JSON.stringify({ ...current, landing: window.location.pathname, ts: Date.now() })
      );
    }
  } catch (e) {
    /* storage may be unavailable */
  }

  return current;
};

export const getFirstTouch = () => {
  try {
    return JSON.parse(localStorage.getItem(FIRST_TOUCH_KEY) || '{}');
  } catch (e) {
    return {};
  }
};

export default trackEvent;
